export enum SpinnerSizeEnum {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}
